export const CP_CALCULATOR = 'cp-calculator-single-page'
export const US_CP_CALCULATOR = 'us-cp-calculator-single-page'
export const ORDER = 'order'

export enum CustomPages {
  CP_CALCULATOR = 'cp-calculator-single-page',
  US_CP_CALCULATOR = 'us-cp-calculator-single-page',
  ORDER = 'order'
}
